import extend from '@/extend';

function install(_Vue) {
  if (install.installed) return;
  install.installed = true;

  extend(_Vue);
}

export default {
  install
};
